import { TextBox } from '@apply/components';
import { isMobileScreen } from '@apply/ui';
import { useBrokerNewReferralStore } from '../../../state/useBrokerNewReferralStore';

interface RepresentativeMiddleNameProps {
    required?: boolean;
}

export const RepresentativeMiddleName: React.FC<RepresentativeMiddleNameProps> = ({ required = false }) => {
    const isMobile = isMobileScreen();
    const label = 'Middle';
    const value = useBrokerNewReferralStore((s) => s.referral.repMiddleName);
    const setValue = useBrokerNewReferralStore((s) => s.set_repMiddleName);
    return (
        <>
            <TextBox
                id='representativeMiddleNameTextBox'
                value={value}
                onChange={(newValue) => setValue(newValue)}
                label={label}
                required={required}
                width={isMobile ? '100%' : '120px'}
            />
        </>
    );
};
